export default {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  ALL: 'all'
}
